import { Injectable } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

@Injectable({
  providedIn: "root",
})
export class IconService {
  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon(
      "locationCity",
      sanitizer.bypassSecurityTrustResourceUrl("assets/location_city.svg")
    );
    iconRegistry.addSvgIcon(
      "hireDate",
      sanitizer.bypassSecurityTrustResourceUrl("assets/event_available.svg")
    );
    iconRegistry.addSvgIcon(
      "peopleLeader",
      sanitizer.bypassSecurityTrustResourceUrl("assets/people-leader.svg")
    );
    iconRegistry.addSvgIcon(
      "mobilePhone",
      sanitizer.bypassSecurityTrustResourceUrl("assets/mobile-phone.svg")
    );
    iconRegistry.addSvgIcon(
      "email",
      sanitizer.bypassSecurityTrustResourceUrl("assets/mail_icon.svg")
    );
    iconRegistry.addSvgIcon(
      "teamsChat",
      sanitizer.bypassSecurityTrustResourceUrl("assets/teams-logo-dark.svg")
    );
    iconRegistry.addSvgIcon(
      "slackChat",
      sanitizer.bypassSecurityTrustResourceUrl("assets/slack-icon.svg")
    );
  }
}
